module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"evidenceTitle":"Evidence","noEvidence":"No evidence added yet."},"de":{"evidenceTitle":"Nachweise","noEvidence":"Noch keine Nachweise hinzugefügt."}}')
  delete Component.options._Ctor
}
